import gql from 'graphql-tag';

export const UPDATE_JWT_TOKEN = gql`
  mutation($refreshToken: String!, $orgId: Int!) {
    refreshJwtToken(
      refreshToken: $refreshToken,
      orgId: $orgId
      userType: PATIENT
    ) {
      jwt
    }
  }
`;
